// Build Google Calendar links and downloadable .ics (Apple/Outlook) from a booking.

function toCalDate(iso) {
  // YYYYMMDDTHHMMSSZ (UTC)
  const d = new Date(iso);
  return d.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
}

function bounds(booking) {
  const start = booking.appointment_datetime;
  const end = new Date(new Date(start).getTime() + (booking.duration_min || 60) * 60000).toISOString();
  return { start, end };
}

function title(booking) {
  return `${booking.service} · ${booking.salon_name || "FYLLR"}`;
}

function location(booking) {
  return booking.address || booking.salon_name || "";
}

export function googleCalendarUrl(booking) {
  if (!booking.appointment_datetime) return null;
  const { start, end } = bounds(booking);
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: title(booking),
    dates: `${toCalDate(start)}/${toCalDate(end)}`,
    details: "Booked with FYLLR — last-minute beauty & wellness.",
    location: location(booking),
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function downloadIcs(booking) {
  if (!booking.appointment_datetime) return;
  const { start, end } = bounds(booking);
  const uid = `${booking.id}@fyllr`;
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//FYLLR//Bookings//EN",
    "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    `UID:${uid}`,
    `DTSTAMP:${toCalDate(new Date().toISOString())}`,
    `DTSTART:${toCalDate(start)}`,
    `DTEND:${toCalDate(end)}`,
    `SUMMARY:${title(booking)}`,
    `LOCATION:${location(booking).replace(/,/g, "\\,")}`,
    "DESCRIPTION:Booked with FYLLR — last-minute beauty & wellness.",
    "BEGIN:VALARM",
    "TRIGGER:-PT2H",
    "ACTION:DISPLAY",
    "DESCRIPTION:FYLLR booking reminder",
    "END:VALARM",
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `fyllr-${(booking.service || "booking").toLowerCase().replace(/\s+/g, "-")}.ics`;
  a.click();
  URL.revokeObjectURL(a.href);
}
